import React from 'react'
import ErrorMessage from '../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../UI/form/MyButton'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { responseError } from '../../../../../helpers/response/ResponseHelper'
import MySpiner from '../../../../UI/spiner/MySpiner'
import { sendToPaySupplyBillsCheckedAPI } from '../../../../../api/supply/supplyBillAPI'
import SuccessMessage from '../../../../UI/messages/SuccessMessage'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../helpers/form/FormData'
import PaymentStatusSelect from '../../../supplyBill/view/payments/forms/changeStatus/fields/PaymentStatusSelect'
import { checkValid, setValueForm, updateValidate } from '../../../../../helpers/form/FormHelper'
import { editSupplyBillsListByBills, setSupplyBillsChecked } from '../../../../../store/supplyBillSlice'

const SendToPayForm = ({ setOpen }) => {

    const checked = useSelector(state => state.supplyBill.supplyBills.checked)
    const dispatch = useDispatch()

    const [data, setData] = useState({}) // Дані з форми

    const [valid, setValid] = useState({}) // Валідація кожного поля
    const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми

    const [count, setCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')

    useEffect(() => {
        checkValid(valid, setIsValidForm)
    }, [valid])

    useEffect(() => {
        changeCountBills()
    }, [checked])

    const changeCountBills = () => {
        let temp = 0

        for (const check in checked) {
            if (checked[check]) {
                temp += 1
            }
        }

        setCount(temp)
    }

    const send = () => {
        setLoading(true)
        setSuccess('')
        setError('')

        sendToPaySupplyBillsCheckedAPI({ 
            checked, status: data.status 
        }).then(data => {
            if (data) {
                dispatch(editSupplyBillsListByBills(data))
                dispatch(setSupplyBillsChecked({}))
            }
            setSuccess('Успішно передано на оплату')
            setLoading(false)
        }).catch (e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

  return (
    <div className='myFormSimple'>
        <div>
            <p>
                Всі обрані рахунки змінять статус в залежності від обраного нижче
            </p>
            <p>
                Обрано рахунків: <b>{ count } шт.</b>
            </p>
        </div>

        {
			formDataProductIsField('status', 'supplyBillPaymentChangeStatus') ?
				<PaymentStatusSelect
					required={formDataProductRequiredField('status', 'supplyBillPaymentChangeStatus')}
					setValidate={e => updateValidate(setValid, 'status', e)}
					setValueForm={e => setValueForm(setData, 'status', e)}
					forciblyValue={data ? data.status : ''}
				/>
			: ''
        }

        {
            loading ? <MySpiner /> : ''
        }
       
        <SuccessMessage
            success={success}
        />
        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={send}
            disabled={!isValidForm || loading ? true : false}
            // disabled={loading ? true : false}
        >
            Надіслати
        </MyButton>
    </div>
  )
}

export default SendToPayForm